import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-theme-toggle',
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.less'],
  standalone: true,
  imports: [IconComponent],
  host: {
    '(click)': 'handleClick($event)',
  },
})
export class ThemeToggleComponent {
  @Input() public isDarkTheme: boolean = false;

  @Output() public themeChanged: EventEmitter<void> = new EventEmitter();

  public handleClick(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();

    this.themeChanged.emit();
  }
}
